// eslint-disable-next-line import/no-anonymous-default-export
export default [
  {
    description: 'Salário',
    amount: '1300.52',
    type: 'entrada',
    frequency: 'recorrente',
    date: '2022-01-10'
  },
  {
    description: 'Freela',
    amount: '150.13',
    type: 'entrada',
    frequency: 'eventual',
    date: '2022-01-17'
  },
  {
    description: 'Salário',
    amount: '2500.23',
    type: 'entrada',
    frequency: 'recorrente',
    date: '2022-02-10'
  },
  {
    description: 'Freela site',
    amount: '900.23',
    type: 'entrada',
    frequency: 'eventual',
    date: '2022-02-21'
  },
  {
    description: 'Freela app',
    amount: '950.92',
    type: 'entrada',
    frequency: 'eventual',
    date: '2022-02-23'
  },
  {
    description: 'Salário',
    amount: '2500.25',
    type: 'entrada',
    frequency: 'recorrente',
    date: '2022-03-10'
  },
  {
    description: 'Salário',
    amount: '2500.18',
    type: 'entrada',
    frequency: 'recorrente',
    date: '2022-04-10'
  },
  {
    description: 'Salário',
    amount: '2500.15',
    type: 'entrada',
    frequency: 'recorrente',
    date: '2022-05-10'
  },
  {
    description: 'Salário',
    amount: '2500.12',
    type: 'entrada',
    frequency: 'recorrente',
    date: '2022-06-10'
  },
  {
    description: 'Salário',
    amount: '2500.00',
    type: 'entrada',
    frequency: 'recorrente',
    date: '2022-07-10'
  }
];
